export default __webpack_public_path__ + "static/media/Group139.1164ac1b.png";